










import Vue from 'vue';
import {ResponseListItem} from 'vue/types/vue';
export default Vue.extend({
    name: 'PuzzleResponseItem',
    props: {
        response: {
            type: Object as () => ResponseListItem,
            default: {} as () => ResponseListItem
        }
    },
    methods: {
        openResponse: function(): void{
            this.$emit('show');
        },

    }


});
